import React from "react";
import { downloadFile } from "../../../utils/download-service";

/** Function for file downloading */
export default function DownloadFile(props) {
	const { labelText,url,filename } = props;
	return (
		<span style={{cursor:"pointer"}} onClick={() => downloadFile(url, filename)}>
			{labelText ? labelText : "Download"}
		</span>
	);
}